import { useTranslation } from 'react-i18next';

export const Affiliation = ({ user }: any) => {
  const { t } = useTranslation();
  return (
    <div>
      <iframe
        allow="clipboard-read; clipboard-write"
        src={`https://v0-dashboard-affiliation.tipsterchat.com?user_id=${user.id}`}
        style={{ width: '100%', height: '100vh', border: 'none' }}
        title="Next.js App"
      />
    </div>
  );
};
